import { Draft } from "@reduxjs/toolkit";
import { GameContext } from "../store/app/sagas/shared/gamesManager/gameFactory";
import { Session } from "../store/app/types/Sessions";

export default function isGameSession(
  session: Draft<Session> | Session,
): session is GameContext {
  return "gameState" in session;
}
